/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitAbridgedCyberBenchmark
 */
export interface MonitAbridgedCyberBenchmark {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MonitAbridgedCyberBenchmark
     */
    overall?: { [key: string]: any; };
}

/**
 * Check if a given object implements the MonitAbridgedCyberBenchmark interface.
 */
export function instanceOfMonitAbridgedCyberBenchmark(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitAbridgedCyberBenchmarkFromJSON(json: any): MonitAbridgedCyberBenchmark {
    return MonitAbridgedCyberBenchmarkFromJSONTyped(json, false);
}

export function MonitAbridgedCyberBenchmarkFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitAbridgedCyberBenchmark {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'overall': !exists(json, 'overall') ? undefined : json['overall'],
    };
}

export function MonitAbridgedCyberBenchmarkToJSON(value?: MonitAbridgedCyberBenchmark | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'overall': value.overall,
    };
}

